import { QueryKeys } from '../../../enums/queryKeys'
import { FetchAccountStatementsPayload } from '../query-api'

export const getAccountStatementsQueryKey = (
  queryProps: FetchAccountStatementsPayload,
): [QueryKeys, FetchAccountStatementsPayload] => [QueryKeys.AccountStatements, queryProps]
